import React from "react";
//import styles
import "./Banner.css";
const Banner = () => {
  return (
    <section className="banner fade-bottom">
      <h1>
        <span>your </span>place <br />
        is waiting for you
      </h1>
    </section>
  );
};

export default Banner;
